function Loader() {
	return (
		<>
			<style>{`
				.loader {
					width: 15px;
					aspect-ratio: 1;
					border-radius: 50%;
					animation: l5 1s infinite linear alternate;
				}

				@keyframes l5 {
					0%   { box-shadow: 20px 0 #808080, -20px 0 #80808022; background: #808080; }
					33%  { box-shadow: 20px 0 #808080, -20px 0 #80808022; background: #80808022; }
					66%  { box-shadow: 20px 0 #80808022, -20px 0 #808080; background: #80808022; }
					100% { box-shadow: 20px 0 #80808022, -20px 0 #808080; background: #808080; }
				}
			`}</style>

			<div className='loader'></div>
		</>
	);
}

export default Loader;
